import { useApi } from 'app/api/APIProvider';
import { AvatarForm } from './ui/AvatarForm/AvatarForm';
import { SignIn } from './ui/SignIn';
import { SignUp } from './ui/SignUp';
import { PassRecovery } from './ui/PassRecovery';
import { PhoneForm } from './ui/PhoneForm/PhoneForm';
import { SmsCode } from './ui/SmsCode/SmsCode';
import { useEffect, useState } from 'react';

export enum FormTypes {
    avatar = 'avatar',
    signIn = 'signIn',
    signUp = 'signUp',
    recovery = 'recovery',
    phone = 'phone',
    sms = 'sms',
}

interface FormProps {
    type: FormTypes,
    stateHandler?: (value: 'm' | 'w') => void,
    statusHandler?: (value: string) => void,
    mothodForSmsRequest?: (value: boolean) => void,
    isSignedUp?: boolean
    step?: string;
}

export const Forms = ({ type, stateHandler, statusHandler, mothodForSmsRequest, isSignedUp, step }: FormProps) => {
    const api = useApi();

    return (
        <>
            {/* {
                type === 'avatar' && <AvatarForm stateHandler={stateHandler}/>
            }
            {
                type === 'signIn' && <SignIn updateUserAuthStatus={statusHandler} />
            }
            {
                type === 'signUp' &&  <SignUp updateUserAuthStatus={statusHandler}/>
            }
            {
                type === 'recovery' &&  <PassRecovery updateUserAuthStatus={statusHandler}/>
            } */}
            {
                type === 'avatar' && <AvatarForm stateHandler={stateHandler}/>
            }
            {
                type === 'phone' &&  <PhoneForm updateUserAuthStatus={statusHandler} methodPicker={mothodForSmsRequest} />
            }
            {
                type === 'sms' &&  <SmsCode step={step} isSignedUp={isSignedUp} />
            }
        </>
    );
};
